import { APIData, appFetch } from ".";

export const settingsAPI = {
  fetch() {
    return appFetch<APIData<Settings>>("/settings");
  },
};
